<template>
  <div class="process_material_list">
    <div class="container-fluid">
      <!-- Begin page -->
      <div class="wrapper">
        <div class="content-page">
          <div class="content">
            <div class="row">
              <div class="col-12">
                <div class="page-title-box">
                  <div class="page-title-right">
                    <Breadcrumb />
                  </div>
                  <h3 class="header-title mb-3">过程材料列表</h3>
                </div>
                <!-- end page-title-box -->
              </div>
              <!-- end col-->
            </div>

            <div class="row">
              <div class="col-12">
                <div class="card">
                  <div class="card-body">
                    <div class="item_title">
                      <div>
                        <i class="el-icon-menu"></i>
                        <span class="topic_level">【{{topicInfo.projectLevelName}}】</span>
                      </div>
                      <el-tooltip class="item" effect="dark" :content="topicInfo.declareName" placement="top">
                        <div class="topic_title">{{ topicInfo.declareName }}</div>
                      </el-tooltip>
                      <span class="topic_time_range">（{{ getTimeRange(topicInfo.projectTime, topicInfo.expectedClosingTime) }}）</span>
                      <span class="topic_project_number">立项编号:{{ topicInfo.projectNumber }}</span>
                      <span class="learning_stages">学段:{{ topicInfo.learningTypeName }}</span>
                      <span class="topic_discipline">学科:{{ topicInfo.disciplineName }}</span>
                      <span class="topic_cate">类别:{{ topicInfo.projectTypeName }}</span>
                    </div>
                    <div class="item_body">
                      <!-- 上传过程材料 -->
                      <div class="process_materials">
                        <div class="process_materials_title">
                          <div>
                            <i class="el-icon-menu"></i>
                            <span class="topic_level">上传过程材料</span>
                            <span style="color: red;">（说明：开题、中期、结题各阶段报告请务必在每个阶段下的“上传报告”处上传）</span>
                          </div>
                          <el-button type="infor" @click="$router.go(-1)">返回</el-button>
                        </div>
                        <div class="process_materials_body">
                          <el-table id="table" :header-cell-style="tableStyle" border ref="multipleTable" :data="processMaterialList" tooltip-effect="dark" style="width: 100%" @selection-change="materialsSelectionChange">
                            <!-- <el-table-column type="selection" width="55"></el-table-column> -->
                            <!-- <el-table-column prop="resourcesName" label="资源名称"></el-table-column> -->
                            <el-table-column prop="title" label="资源名称">
                              <template v-slot="scope">
                                <el-button type="text" @click="downloadFile(scope.row)">
                                  {{scope.row.title}}</el-button>
                              </template>
                            </el-table-column>
                            <el-table-column prop="createUserName" label="上传人" width="120px"></el-table-column>
                            <el-table-column prop="createUnitName" label="所属单位"></el-table-column>
                            <el-table-column prop="type" label="资料类型" width="100px">
                              <template v-slot="scope">
                                {{ scope.row.type | getType }}
                              </template>
                            </el-table-column>
                            <el-table-column prop="createTime" label="上传时间" width="110px">
                              <template v-slot="scope">
                                {{ scope.row.createTime | getTime }}
                              </template>
                            </el-table-column>
                            <el-table-column prop="" label="操作" width="100px">
                              <template v-slot="scope">
                                <el-button type="text" @click="editProcessMaterial(scope.row)">修改
                                </el-button>
                                <el-button type="text" @click="delProcessMaterial(scope.row.id)">删除
                                </el-button>
                              </template>
                            </el-table-column>
                          </el-table>
                          <div class="pagination">
                            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="processMaterialParams.pageNumber" :page-sizes="[10, 20, 50, 100]" :page-size="processMaterialParams.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
                            </el-pagination>
                          </div>
                          <div class="btn_wrap">
                            <el-button type="primary" @click="openUploadMaterialsDialog('add')">上传</el-button>
                            <!-- <el-button type="primary" @click="openUploadMaterialsDialog('edit')">修改</el-button> -->
                            <!-- <el-button type="primary">删除</el-button> -->
                            <el-button type="primary" @click="exportExcel">导出Excel
                            </el-button>
                            <el-button type="primary" :loading='exportMaterialLoading' @click="exportMaterial">导出资料</el-button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- end card-body-->
                </div>
                <!-- end card -->
              </div>
              <!-- end col-->
            </div>
          </div>
        </div>
      </div>
      <!-- end wrapper-->
    </div>
    <!-- 上传课题资料对话框 -->
    <el-dialog :title="uploadTopicDialogTitle" :visible.sync="uploadProcessMaterialDialogVisible" width="50%" :before-close="handleClose">
      <el-form :model="uploadProcessMaterialForm" :rules="uploadProcessMaterialRules" ref="uploadProcessMaterialFormRef" label-width="100px" class="demo-uploadProcessMaterialForm">
        <el-form-item label="选择资源" prop="resourcesId">
          <UploadFile @file-event="changeData('resource', $event)" :value="uploadProcessMaterialForm.resource" />
          <span style="color: red;">(文件最大不超过300MB)</span>
        </el-form-item>
        <el-form-item label="标题" prop="title">
          <el-input v-model="uploadProcessMaterialForm.title"></el-input>
        </el-form-item>
        <el-form-item label="资料类型" prop="type">
          <el-radio-group v-model="uploadProcessMaterialForm.type">
            <el-radio :label="0">文档</el-radio>
            <el-radio :label="1">图片</el-radio>
            <el-radio :label="2">视频（限300MB）</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="uploadProcessMaterialDialogVisible = false">返 回</el-button>
        <el-button type="primary" @click="uploadProcessMaterial">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="视频预览" :visible.sync="filePreviewDialogVisible" width="50%" :before-close="closePreviewFileDialog">
      <div class="preview_wrap">
        <video ref="previewVideo" style="width: 500px;height: 400px;" autoplay controls :src="curPreviewFileUrl"></video>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closePreviewFileDialog">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from '@/views/backstage/components/Breadcrumb.vue';
import UploadFile from './components/UploadFile.vue';
import {
  getProcessMaterialList,
  uploadOrEditProcessMaterial,
  delProcessMaterial,
  exportProcessMaterials
} from '@/api/after/topicManage.js';
import {
  downloadFile
} from '@/api/public.js'
import FileSaver from "file-saver";
import XLSX from "xlsx";
export default {
  components: {
    Breadcrumb,
    UploadFile
  },
  data() {
    return {
      curPreviewFileUrl: '',//视频附件url
      filePreviewDialogVisible: false,//附件预览弹框
      processMaterialList: [],
      total: 0,
      uploadTopicDialogTitle: '', //上传课题对话框标题
      // 上传课题资料
      uploadProcessMaterialDialogVisible: false,
      uploadProcessMaterialForm: {
        resourcesId: '', //资源id
        resourcesName: '', //资源名称
        resource: {
          id: '',
          name: ''
        }, //资源名称
        title: '', //标题
        type: '', //(0:文档，1:图片,2:视频)
        projectManagementId: '' //课题管理id
      },
      uploadProcessMaterialRules: {
        resourcesId: [{
          required: true,
          message: '请上传资源',
          trigger: 'change'
        }],
        title: [{
          required: true,
          message: '请输入标题',
          trigger: 'blur'
        }],
        type: [{
          required: true,
          message: '请选择资料类型',
          trigger: 'change'
        }]
      },
      topicInfo: {}, //课题信息
      tableStyle: {
        backgroundColor: '#4da7dc',
        color: '#fff',
        textAlign: 'center'
      },
      //获取过程材料参数
      processMaterialParams: {
        id: 0,
        pageNumber: 1,
        pageSize: 10
      },
      exportMaterialLoading: false,//导出材料加载中
    };
  },
  filters: {
    getType(val) {
      switch (val) {
        case 0:
          return '文档';
          break;
        case 1:
          return '图片';
          break;
        case 2:
          return '视频';
          break;
        default:
          return '错误的文件';
      }
    }
  },
  computed: {
    getTimeRange(val1, val2) {
      return (val1, val2) => {
        if (val1) {
          return val1.slice(0, 7) + ' ~ ' + val2.slice(0, 7);
        }
      };
    }
  },
  created() {
    if (this.$route.query.data) {
      let data = JSON.parse(decodeURIComponent(this.$route.query.data));
      console.log('传递过来的数据', data);
      this.topicInfo = data;
      // 赋值ID用户获取过程材料列表丶添加和编辑过程材料
      this.processMaterialParams.id = data.id;
      this.getProcessMaterialList();
    } else {
      this.$message.error('参数错误!');
      this.$router.go(-1);
    }
  },
  methods: {
    // 关闭文件预览对话框
    closePreviewFileDialog() {
      this.filePreviewDialogVisible = false
      this.$refs.previewVideo.pause();
    },
    // 预览过程材料
    async downloadFile(fileData) {
      console.log(fileData.resourcesName);
      if (/\.(png|jpeg|jpg|gif|PNG|JPEG|JPG|GIF)$/.test(fileData.resourcesName)) {
        window.open(`${this.uploadUrl}/upload/previewImage/${fileData.resourcesId}`, '_blank')
      } else if (/\.(doc|docx|DOC|DOCX)$/.test(fileData.resourcesName)) {
        window.open(`${this.uploadUrl}/upload/downloadPdf/${fileData.resourcesId}`, '_blank')
      } else if (/\.(mp4|rm|rmvb|3gp|avi|mpeg|mpg|mkv|dat|asf|wmv|flv|mov|ogg|ogm|RM|RMVB|3GP|AVI|MPEG|MPG|MKV|DAT|ASF|WMV|FLV|MOV|MP4|OGG|OGM)$/.test(fileData.resourcesName)) {
        this.curPreviewFileUrl = `${this.uploadUrl}/upload/previewVideo/${fileData.resourcesId}`
        this.filePreviewDialogVisible = true
        // window.open(`${this.uploadUrl}/upload/previewVideo/${fileData.resourcesId}`, '_blank')// 视频
      } else if (/\.(pdf|PDF)$/.test(fileData.resourcesName)) {
        window.open(`${this.uploadUrl}/upload/previewPdf/${fileData.resourcesId}`, '_blank')
      } else if (/\.(pptx|PPTX)$/.test(fileData.resourcesName)) {
        window.open(`${this.uploadUrl}/upload/pptConversionPdf/${fileData.resourcesId}`, '_blank')
      } else {
        window.open(`${this.uploadUrl}/upload/download?id=${fileData.resourcesId}&openStyle=1`, '_blank')
      }
      return
      const res = await downloadFile(fileData.resourcesId)
      //创建一个a标签并实现下载功能
      const link = document.createElement('a');
      let blob = new Blob([res], {
        type: 'application/octet-stream'
      }); //res是文件流
      link.style.display = 'none';
      link.href = URL.createObjectURL(blob);
      link.download = `${fileData.resourcesName}`; //下载的文件名
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    //导出Excel
    exportExcel() {
      var xlsxParam = {
        raw: true
      };
      var wb = XLSX.utils.table_to_book(
        document.querySelector("#table"),
        xlsxParam
      );
      var wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array",
      });
      try {
        FileSaver.saveAs(
          new Blob([wbout], {
            type: "application/octet-stream"
          }),
          `${this.topicInfo.declareName}课题的过程材料表格.xlsx`
        );
      } catch (e) {
        if (typeof console !== "undefined") {
          console.log(e, wbout);
        }
      }
      return wbout;
    },
    //导出资源zip
    async exportMaterial() {
      this.exportMaterialLoading = true;
      const res = await exportProcessMaterials(this.topicInfo.id)
      //创建一个a标签并实现下载功能
      const link = document.createElement('a');
      let blob = new Blob([res], {
        type: 'application/octet-stream'
      }); //res是文件流
      link.style.display = 'none';
      link.href = URL.createObjectURL(blob);
      link.download = `${this.topicInfo.declareName}过程材料.zip`; //下载的文件名
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      this.exportMaterialLoading = false;
      this.$message.success('导出过程材料成功！')
    },
    handleSizeChange(val) {
      this.processMaterialParams.pageSize = val
      this.getProcessMaterialList()
    },
    handleCurrentChange(val) {
      this.processMaterialParams.pageNumber = val
      this.getProcessMaterialList()
    },
    // 修改过程材料
    editProcessMaterial(data) {
      this.uploadProcessMaterialForm = JSON.parse(JSON.stringify(data));
      this.uploadProcessMaterialForm.resource = {
        id: this.uploadProcessMaterialForm.resourcesId,
        name: this.uploadProcessMaterialForm.resourcesName
      }
      this.uploadProcessMaterialDialogVisible = true
    },
    // 删除过程材料
    delProcessMaterial(id) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          const res = await delProcessMaterial(id)
          if (res.code == 200) {
            this.$message.success('删除成功！')
            this.processMaterialParams.pageNumber = 1;
            this.getProcessMaterialList();
          } else {
            this.$message.error(res.data)
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    // 上传过程材料
    uploadProcessMaterial() {
      this.$refs.uploadProcessMaterialFormRef.validate((valid) => {
        if (valid) {
          this.uploadOrEditProcessMaterial();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
      // console.log(this.uploadProcessMaterialForm);
    },
    // 上传或者编辑过程材料
    async uploadOrEditProcessMaterial() {
      this.uploadProcessMaterialForm.projectManagementId = this.topicInfo.id;
      const res = await uploadOrEditProcessMaterial(this.uploadProcessMaterialForm);
      if (res.code == 200) {
        this.$message.success('上传成功！');
        this.resetUploadProcessMaterialForm();
        this.uploadProcessMaterialDialogVisible = false
        this.processMaterialParams.pageNumber = 1;
        this.getProcessMaterialList();
      } else {
        this.$message.error(res.data);
      }
    },
    // 重置上传或修改过程材料表单
    resetUploadProcessMaterialForm() {
      this.uploadProcessMaterialForm = {
        resourcesId: '', //资源id
        resourcesName: '', //资源名称
        resource: {
          id: '',
          name: ''
        }, //资源名称
        title: '', //标题
        type: '', //(0:文档，1:图片,2:视频)
        projectManagementId: this.topicInfo.id //课题管理id
      };
    },
    // 获取过程材料列表
    async getProcessMaterialList() {
      const res = await getProcessMaterialList(this.processMaterialParams);
      if (res.code == 200) {
        console.log('过程材料', res);
        this.processMaterialList = res.data.records;
        this.total = res.data.total;
      } else {
        this.$message.error(res.data);
      }
    },
    changeData(name, data) {
      this.uploadProcessMaterialForm[name] = data;
      this.uploadProcessMaterialForm.resourcesId = data.id;
      this.uploadProcessMaterialForm.resourcesName = data.name;
	  if(!this.uploadProcessMaterialForm.title){
		  this.uploadProcessMaterialForm.title = data.name.slice(0, data.name.indexOf('.'));
	  }
    },
    // 多选
    materialsSelectionChange(val) { },
    // 打开上传材料对话框
    openUploadMaterialsDialog(type) {
      if (type == 'add') {
        this.uploadTopicDialogTitle = '上传课题资料';
        this.resetUploadProcessMaterialForm();
      } else {
        this.uploadTopicDialogTitle = '修改课题资料';
      }
      this.uploadProcessMaterialDialogVisible = true;
    },
    // 关闭上传报告对话框
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done();
        })
        .catch(_ => { });
    }
  }
};
</script>

<style scoped lang="scss">
.preview_wrap {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
}

.item_title {
  display: flex;
  align-items: center;
  // justify-content: space-between;
  border-bottom: 1px solid #eee;
  height: 50px;

  .topic_level {
    font-weight: bolder;
  }

  .topic_title {
    font-size: 16px;
    max-width: 300px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  .topic_time_range {
  }

  .topic_project_number {
  }

  .learning_stages {
  }

  .topic_discipline {
  }

  .topic_cate {
  }
}

.process_materials_title,
.change_request_title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 10px 0;
}

.btn_wrap {
  margin-top: 10px;
}

.custom_table {
  height: 40px;
  line-height: 40px;
  text-align: center;
  background-color: #d0e4f5;
  color: #2d87bd;
}

.upload_change_topic_info_form {
  ::v-deep .el-form-item {
    margin-bottom: 0;
  }

  ::v-deep .el-row {
    display: flex;
    align-items: center;
    padding: 10px 0;
    border: 1px solid #dfedfc;
  }

  ::v-deep .el-row:first-child {
    padding: 0 !important;
  }

  .form_item_title {
    display: inline-block;
    width: 130px;
    padding-right: 10px;
    text-align: right;
  }

  .tip {
    color: red;
  }
}
</style>
